import React from "react";

import { faTimes } from "@awesome.me/kit-4c83d50d0d/icons/classic/light";
import { faSignalStream } from "@awesome.me/kit-4c83d50d0d/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";
import { AnimatePresence, motion } from "framer-motion";

import OngoingMeetingContext from "~/OngoingMeetingContext";
import { Button, LinkButton } from "~/ui";

import styles from "./ReturnToMeetingPrompt.module.css";

export default function ReturnToMeetingPrompt() {
	const { ongoingMeeting, dismissPrompt } = React.useContext(OngoingMeetingContext);

	return (
		<AnimatePresence initial={false}>
			{ongoingMeeting && (
				<motion.div
					key="return-to-meeting-prompt"
					className={cx("invert-theme", styles.container)}
					layout
					// 10px is the value of bottom
					initial={{ translateY: "calc(100% + 10px)" }}
					animate={{ translateY: 0 }}
					exit={{ translateY: "calc(100% + 10px)" }}
					transition={{ duration: 0.5, ease: "easeOut" }}
				>
					<LinkButton to={ongoingMeeting.url} variant="tertiary" className={styles.confirmButton}>
						<FontAwesomeIcon icon={faSignalStream} />
						Return to &quot;{ongoingMeeting.title}&quot;
					</LinkButton>
					<Button variant="tertiary" onClick={dismissPrompt} className={styles.dismissButton}>
						<FontAwesomeIcon icon={faTimes} />
					</Button>
				</motion.div>
			)}
		</AnimatePresence>
	);
}
